// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6f7c1076","590":"d1b38137","729":"99af846b"}[chunkId] + ".chunk.js";
};